module.exports = __webpack_public_path__ + "static/media/projects_image.9f3c9529.svg";